import { ScreenEnum } from 'feature/screenMode'
import { TSuggest } from 'feature/registration/types'
import { Checkbox, FormControlLabel, TextField } from 'ui'
import { ActualAddressInput } from './ActualAddressInput'
import styles from '../CompanyRegistration.module.scss'

type ActualAddressSectionProps = {
  sameAsLegal: boolean
  onSameAsLegalChange: (checked: boolean) => void
  legalAddressWatch: TSuggest | null
  setViewMode: (str: string) => void
  screen: ScreenEnum | undefined
}

export function ActualAddressSection({
  sameAsLegal,
  onSameAsLegalChange,
  legalAddressWatch,
  setViewMode,
  screen,
}: ActualAddressSectionProps) {
  return (
    <div className={styles.companyRegistration__section}>
      <h3 className={styles.companyRegistration__sectionTitle}>
        Фактический адрес
      </h3>
      <FormControlLabel
        control={
          <Checkbox
            checked={sameAsLegal}
            onChange={e => onSameAsLegalChange(e.target.checked)}
            data-testid='company-reg-same-as-legal'
          />
        }
        label='Совпадает с юридическим'
      />
      {sameAsLegal ? (
        <div className={styles.companyRegistration__addressInput}>
          <TextField
            value={legalAddressWatch?.address || ''}
            label='Адрес'
            required
            multiline
            maxRows={screen !== ScreenEnum.desktop ? 10 : 2}
            disabled
            type='text'
            data-testid='company-reg-actual-address-display'
          />
        </div>
      ) : (
        <ActualAddressInput setViewMode={setViewMode} />
      )}
    </div>
  )
}
